package fr.arcplex.sooner.webui

import fr.arcplex.network.model.ItemAction
import fr.arcplex.network.model.RailItem

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import fr.arcplex.sooner.ui.theme.TVOverlay

@Composable
fun FilmInfoView(
    page: Page,
    modifier: Modifier = Modifier,
    onRailItemClicked: ((RailItem) -> Unit)? = null,
    onMenuItemClicked: ((RailItem) -> Unit)? = null,
    isTV: Boolean = false,
    menuOpen: Boolean = false,
    onMenuToggle: () -> Unit = {},
    onMenuDismiss: () -> Unit = {}
) {
    val backgroundColor = parseColor(page.bgColor ?: "#0A0E17")
    val videoInfo = page.getVideoInformation()

    Box(modifier = modifier.fillMaxSize()) {
        Box(modifier = Modifier.fillMaxSize()) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(backgroundColor)
            )

            Column(modifier = Modifier.fillMaxSize()) {
                if (isTV) {
                    TVAppBar(
                        page = page,
                        onMenuToggle = onMenuToggle
                    )
                } else if (page.menu.items.isNotEmpty()) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(56.dp)
                    ) {
                        Card(
                            onClick = onMenuToggle,
                            modifier = Modifier
                                .align(Alignment.CenterStart)
                                .padding(start = 8.dp)
                                .height(48.dp)
                                .padding(horizontal = 16.dp)
                        ) {
                            Text(
                                text = "☰",
                                modifier = Modifier.padding(8.dp)
                            )
                        }
                    }
                }

                if (isTV && page.fixed_element.items.isNotEmpty()) {
                    TVHeroBanner(
                        items = page.fixed_element.items,
                        onRailItemClicked = onRailItemClicked,
                        modifier = Modifier.fillMaxWidth()
                    )
                } else if (page.fixed_element.items.isNotEmpty()) {
                    RailView(
                        rail = page.fixed_element,
                        modifier = Modifier.fillMaxWidth(),
                        centerContent = true,
                        onRailItemClicked = onRailItemClicked,
                        isTV = isTV
                    )
                }

                if(videoInfo == null) {
                    LazyColumn(
                        modifier = Modifier
                            .weight(1f)
                            .fillMaxWidth(),
                        contentPadding = PaddingValues(vertical = 8.dp)
                    ) {
                        items(page.rails, key = { it.uid }) { rail ->
                            RailView(
                                rail = rail,
                                onRailItemClicked = onRailItemClicked,
                                isTV = isTV
                            )
                        }
                    }
                } else {
                    val info = videoInfo

                    Column(
                        modifier = Modifier
                            .weight(1f)
                            .fillMaxWidth()
                            .padding(horizontal = 16.dp, vertical = 8.dp)
                    ) {
                        if (info.actions.isNotEmpty()) {
                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(top = 12.dp),
                                horizontalArrangement = Arrangement.spacedBy(8.dp),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                info.actions.forEach { actionUrl ->
                                    OutlinedButton(
                                        onClick = {
                                            println("Action clicked: $actionUrl")
                                                  if(actionUrl.contains("viewVideo")) {
                                                      onRailItemClicked?.invoke(
                                                          RailItem(
                                                              uid = "",
                                                              type = "FILM",
                                                              content = "",
                                                              action = ItemAction(url = actionUrl),
                                                              height = 0f,
                                                              width = 0f
                                                          )
                                                      )
                                                  }
                                                  },
                                        modifier = Modifier.weight(1f)
                                    ) {
                                        val label = when {
                                            actionUrl.contains("viewVideo") && actionUrl.contains("FILM") -> "Voir le film"
                                            actionUrl.contains("viewVideo") && actionUrl.contains("BA") -> "Bande Annonce"
                                            actionUrl.contains("addFilmFavoris") -> "Ajouter aux favoris"
                                            else -> actionUrl.substringAfterLast('/').substringBefore('?').takeIf { it.isNotEmpty() } ?: actionUrl
                                        }
                                        Text(text = label)
                                    }
                                }
                            }
                        }

                        if (info.title.isNotBlank()) {
                            Text(
                                text = info.title,
                                style = MaterialTheme.typography.headlineLarge.copy(
                                    fontWeight = FontWeight.Bold
                                ),
                                color = MaterialTheme.colorScheme.onSurface,
                                maxLines = 2,
                                overflow = TextOverflow.Ellipsis
                            )
                        }

                        if (info.infostech != null && info.infostech!!.isNotBlank()) {
                            Text(
                                text = info.infostech!!,
                                style = MaterialTheme.typography.labelSmall,
                                color = MaterialTheme.colorScheme.onSurfaceVariant,
                                modifier = Modifier.padding(top = 4.dp)
                            )
                        }

                        if (info.director != null && info.director!!.isNotBlank()) {
                            Text(
                                text = info.director!!,
                                style = MaterialTheme.typography.bodyMedium,
                                color = MaterialTheme.colorScheme.onSurfaceVariant,
                                modifier = Modifier.padding(top = 4.dp)
                            )
                        }

                        if (info.tags.isNotEmpty()) {
                            Row(
                                modifier = Modifier.padding(top = 4.dp),
                                horizontalArrangement = Arrangement.spacedBy(4.dp),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                info.tags.forEach { tag ->
                                    Card(
                                        onClick = {},
                                        shape = RoundedCornerShape(12.dp),
                                        colors = CardDefaults.cardColors(
                                            containerColor = MaterialTheme.colorScheme.surfaceVariant
                                        )
                                    ) {
                                        Text(
                                            text = tag,
                                            style = MaterialTheme.typography.labelSmall,
                                            modifier = Modifier.padding(horizontal = 8.dp, vertical = 2.dp)
                                        )
                                    }
                                }
                            }
                        }

                        if (info.description.isNotBlank()) {
                            Text(
                                text = info.description,
                                style = MaterialTheme.typography.bodyMedium,
                                color = MaterialTheme.colorScheme.onSurfaceVariant,
                                modifier = Modifier.padding(top = 8.dp),
                                maxLines = 6,
                                overflow = TextOverflow.Ellipsis
                            )
                        }



                        if (info.casting.isNotEmpty()) {
                            Text(
                                text = "Casting: ${info.casting.joinToString(", ")}",
                                style = MaterialTheme.typography.bodySmall,
                                color = MaterialTheme.colorScheme.onSurfaceVariant,
                                modifier = Modifier.padding(top = 8.dp)
                            )
                        }

                    }
                }
            }
        }

        if (menuOpen && page.menu.items.isNotEmpty()) {
            AppMenu(
                menu = page.menu,
                isOpen = menuOpen,
                coherence = false,
                isTV = isTV,
                onDismiss = onMenuDismiss,
                onItemClicked = { item -> onMenuItemClicked?.invoke(item) }
            )
        }
    }
}
